module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-thorben.7a621d5b.jpeg";